// API base URLs. Production defaults target the first-party aquinocompliance.com stack (SPA + workers
// share the registrable domain → first-party httpOnly session cookie in every browser). Override with
// VITE_* vars. PLAN-C1.9.
export const API_BASE = {
  tenant: import.meta.env.VITE_TENANT_API ?? "https://api.aquinocompliance.com",
  admin: import.meta.env.VITE_ADMIN_API ?? "https://admin-api.aquinocompliance.com",
  mcp: import.meta.env.VITE_MCP_API ?? "https://mcp.aquinocompliance.com",
  billing: import.meta.env.VITE_BILLING_API ?? "https://billing.aquinocompliance.com",
} as const;

/** The auth-worker (identity broker) — login / callback / me / logout. PLAN-C1.3. */
export const AUTH_BASE = import.meta.env.VITE_AUTH_BASE_URL ?? "https://auth.aquinocompliance.com";

/** Canonical production origin for this SPA (legacy *.pages.dev URLs forward here so the session
 *  cookie stays first-party). */
export const APP_ORIGIN = import.meta.env.VITE_APP_ORIGIN ?? "https://app.aquinocompliance.com";

/** Stripe publishable key (public by design) — set as a Pages build var. */
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? "";
